import UploadMaterialStock from './UploadMaterialStock';

export { UploadMaterialStock };
export default { UploadMaterialStock };
